export class UpdatePaymentId {
  static readonly type = '[Reservation] Update Payment Id';
  constructor(public paymentId: string | null) {}
}
